import { getUploadUrl } from '@/service/file';
import { compressDxfBasemapContext } from './codec';
import type { DxfBasemapContext } from './types';

const DXF_BASEMAP_CONTEXT_EXTENSION = '.basemap.json.gz';

function getBasemapContextFileName(fileName: string) {
  const trimmedName = fileName.trim();
  if (!trimmedName) return `floorplan${DXF_BASEMAP_CONTEXT_EXTENSION}`;

  const normalized = trimmedName.replace(/\.[^.]+$/, '');
  return `${normalized}${DXF_BASEMAP_CONTEXT_EXTENSION}`;
}

export async function uploadDxfBasemapContext(
  context: DxfBasemapContext,
  sourceFileName: string,
  onProgress?: (progress: number) => void
) {
  const compressed = await compressDxfBasemapContext(context);
  const file = new File([compressed], getBasemapContextFileName(sourceFileName), {
    type: 'application/gzip'
  });

  return await getUploadUrl({
    file,
    urlType: 'BASE_MAP',
    onProgress
  });
}
